import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import axios from "@/lib/axios";
import { ReportType, UpsertManyReportsResponse } from "../types/Api";
import {
  MANUAL_VALVE_REPORTS_API,
  SAFETY_VALVE_REPORTS_API,
} from "../config/api";

export const upsertManyReports = async (
  formData: FormData
): Promise<AxiosResponse<UpsertManyReportsResponse>> =>
  axios.put("/api/safetyValveReport", formData);

export const upsertManyManualValveReports = async (
  formData: FormData
): Promise<AxiosResponse<UpsertManyReportsResponse>> =>
  axios.put("/api/manualValveRepairReport", formData);

export const useUpsertManyReports = (
  reportType: ReportType = "SAFETY_VALVE"
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn:
      reportType === "SAFETY_VALVE"
        ? upsertManyReports
        : upsertManyManualValveReports,
    onSettled: () => {
      if (reportType === "SAFETY_VALVE") {
        queryClient.invalidateQueries([SAFETY_VALVE_REPORTS_API]);
      }
      if (reportType === "MANUAL_VALVE") {
        queryClient.invalidateQueries([MANUAL_VALVE_REPORTS_API]);
      }
    },
  });
};

type UploadAttachmentsParams = {
  location: string;
  reportId: number | string;
  formData: FormData;
  reportType?: ReportType;
};

export const uploadAttachments = async ({
  location,
  reportId,
  formData,
  reportType = "SAFETY_VALVE",
}: UploadAttachmentsParams): Promise<AxiosResponse> => {
  if (reportType === "MANUAL_VALVE") {
    return axios.post(
      `/api/manualValveRepairReport/${location}/${reportId}/attachment`,
      formData
    );
  }

  return axios.post(
    `/api/safetyValveReport/${location}/${reportId}/attachment`,
    formData
  );
};

type DuplicateAndArchiveReportParams = {
  location: string;
  reportId: number | string;
  reportType?: ReportType;
};

export const duplicateAndArchiveReport = async ({
  location,
  reportId,
  reportType = "SAFETY_VALVE",
}: DuplicateAndArchiveReportParams) => {
  if (reportType === "MANUAL_VALVE") {
    return axios.post(
      `/api/manualValveRepairReport/${location}/${reportId}/w-archive`
    );
  }

  return axios.post(`/api/safetyValveReport/${location}/${reportId}/w-archive`);
};
